<i18n>
{
  "en": { 
    "pwd": { 
      "change_password": "Change Password",
      "enter_new_password": "Enter a new password below",
      "new_password": "New password",
      "confirm_new_password": "Confirm new password",
      "submit": "Submit",
      "has_been_reset": "Password has been reset",
      "try_logging_in": "Try logging in with your new password in respective application.",
      "please_enter_both_passwords": "Please enter both new password and confirm new password.",
      "passwords_no_match": "Passwords don't match.",
      "something_went_wrong": "Something went wrong. Please try re-sending your password reset link.",
      "token_expired": "Password reset request is only valid 20 minutes and has expired.",
      "thepasswordcontainsspaceorforbiddencharacters": "The password contains forbidden characters: ' & / <; >; , . = or space.",
      "thepasswordhastobe8charactersorlongerandmustinclude1numeralandspecialcharacter": "The password has to be 8 characters or longer, and must include 1 numeral and special character."
    }
  },
  "da": { 
    "pwd": { 
      "change_password": "Skift kodeord",
      "enter_new_password": "Indtast en ny adgangskode nedenfor",
      "new_password": "Nyt kodeord",
      "confirm_new_password": "Bekræft ny adgangskode",
      "submit": "Indsend",
      "has_been_reset": "Adgangskoden er nulstillet",
      "try_logging_in": "Prøv at logge ind med din nye adgangskode i den respektive applikation.",
      "please_enter_both_passwords": "Indtast venligst både ny adgangskode og bekræft ny adgangskode.",
      "passwords_no_match": "Adgangskoder stemmer ikke overens.",
      "something_went_wrong": "Noget gik galt. Prøv at sende dit link til nulstilling af adgangskode igen.",
      "token_expired": "Din adgang til at nulstille din adgangskode er udløbet. Anmod om nulstilling på ny, for at modtage et nyt link.",
      "thepasswordcontainsspaceorforbiddencharacters": "Adgangskoden indeholder forbudte tegn: ' & / <; >; , . = eller mellemrum.",
      "thepasswordhastobe8charactersorlongerandmustinclude1numeralandspecialcharacter": "Adgangskoden skal være på 8 tegn eller længere og skal indeholde 1 tal og specialtegn."
    }
  },
  "ja": { 
    "pwd": { 
      "change_password": "パスワードの再設定",
      "enter_new_password": "新しいパスワードを入力してください",
      "new_password": "新しいパスワード",
      "confirm_new_password": "パスワードの再入力",
      "submit": "送信",
      "has_been_reset": "パスワードはリセットされました",
      "try_logging_in": "新しいパスワードでアプリにログインしてください",
      "please_enter_both_passwords": "新しいパスワードと確認用パスワードの両方を入力してください。",
      "passwords_no_match": "パスワードが一致しません",
      "something_went_wrong": "エラーが発生しました。パスワードの再設定リンクを送信しなおしてください。",
      "token_expired": "パスワード再設定用のリンクの有効期限は20分です。有効期限が切れましたので、再度リクエストを送信してください。",
      "thepasswordcontainsspaceorforbiddencharacters": "パスワードに次の記号とスペース(空白)は使用できません： ’ & / <; >; , . =",
      "thepasswordhastobe8charactersorlongerandmustinclude1numeralandspecialcharacter": "パスワードには、8文字以上の半角英数字記号を使用してください。ただし、数字1文字以上、記号1文字以上を含む必要があります"
    }
  }
}
</i18n>

<template>
  <div class="gt-box">
    <div class="container mt-6" v-if="token">
      <img v-if="appid == 36 || appid == 37 || app == '5fb50fc5-e3d9-4a85-bf93-edecec1661a4' || app == 'Fuse Fleet'" src="https://cdn.greaterthan.eu/fma/100/e49e1edc-b8ae-4197-9de6-4eb0ed8017a1" alt="logo">
      <img v-else-if="appid == 12 || app == 'c196ddbe-ba8f-46cc-a547-d376250e65ef' || app == 'FIA SDC'" src="https://cdn.greaterthan.eu/fma/100/94ffc785-aa94-433b-a6c6-1f83c832b745.png" alt="logo">
      <img v-else-if="app == 'DSI'" src="http://cdn.mcauto-images-production.sendgrid.net/fc318e8506a180a6/055d078b-17bd-44ad-b143-4d2d60f42e94/118x80.png" alt="logo">
      <img v-else-if="app == 'Ctrack'" src="http://cdn.mcauto-images-production.sendgrid.net/fc318e8506a180a6/daaf8d69-9e50-4bee-aea7-600e169ae4f3/500x300.png" alt="logo">
      <img v-else-if="app == 'The data hub'" src="http://cdn.mcauto-images-production.sendgrid.net/fc318e8506a180a6/ee89b8e9-d106-4d58-857a-62050c3f9a46/1090x316.png" alt="logo">
      <img v-else-if="app == 'Lifesaver'" src="http://cdn.mcauto-images-production.sendgrid.net/fc318e8506a180a6/ed507a31-7f2a-46fe-afc0-c36d22e8d68b/700x200.png" alt="logo">
      <img v-else src="https://greaterthan.eu/wp-content/themes/greaterthan/assets/img/logo.svg">
      <div class="box content">
        <h1>{{ $t('pwd.change_password') }}</h1>
        <h4>{{ $t('pwd.enter_new_password') }}</h4>

        <div>
          <input
            style="margin-bottom: 10px"
            class="input" 
            :placeholder="$t('pwd.new_password')"
            v-model="form.newPassword"
            :disabled="hasBeenReset"
            :type="showNewPassword ? 'text' : 'password'"
          />
          <i :class=" showNewPassword? 'far fa-eye': 'far fa-eye-slash'" class="password-icon" @click="showNewPassword = !showNewPassword"/>

        </div>

        <div>
          <input
            style="margin-bottom: 10px"
            class="input"
            :placeholder="$t('pwd.confirm_new_password')"
            v-model="form.confirmPassword"
            :disabled="hasBeenReset"
            :type="showConfirmPassword ? 'text' : 'password'"
          />
          <i :class="showConfirmPassword? 'far fa-eye': 'far fa-eye-slash'" class="password-icon" @click="showConfirmPassword = !showConfirmPassword"/>

        </div>

        <div
          class="error-msg notification is-secondary errorNotification"
          style="margin-top: -4px"
          v-for="(error, i) in errors"
          :key="i"
        >
          {{ error }}
        </div>

        <button
          v-if="!hasBeenReset"
          class="button is-info"
          style="width: 100%; margin-bottom: 25px"
          @click="resetPassword"
        >
          {{ $t('pwd.submit') }}
        </button>

        <div style="margin-top: 20px" v-if="hasBeenReset">
          <h3 style="font-weight: 300">{{ $t('pwd.has_been_reset') }}</h3>
          <p>{{ $t('pwd.try_logging_in') }}</p>
        </div>

        <b-loading
          :is-full-page="false"
          :active.sync="isLoading"
          :can-cancel="false"
        ></b-loading>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'PasswordReset',
  data() {
    return {
      isLoading: false,
      hasBeenReset: false,
      errors: [],
      URL: "https://app04.azurewebsites.net/v2/account/password",
      URL2: "https://internalapi.enerfyglobal.com/account/ResetPassword",
      token: "",
      appid: null,
      app: null,
      form: {
        newPassword: '',
        confirmPassword: ''
      },
      showNewPassword: false,
      showConfirmPassword: false
    };
  },
  methods: {
    clearErrors() {
      this.errors = [];
    },
    addError(msg) {
      this.errors.push(msg);
    },
    validateForm() {
      /*
        Validates form input locally before sending to server
      */ 
     
      const notTheseChars = /[',=.&/<>\s]/;
      const mustContainTheseChars =
        /^(?=.*\d)(?=.*[^a-zA-Z\d\s:])(?=.*[a-z]).{8,}$/;

      const containsForbiddenChars = notTheseChars.test(this.form.newPassword);
      const containsRequiredChars = mustContainTheseChars.test(
        this.form.newPassword
      );

      let errors = [];
      if (this.form.newPassword == '' || this.form.confirmPassword == '') {
        errors.push(this.$t('pwd.please_enter_both_passwords'));
      }
      if (this.form.newPassword != this.form.confirmPassword) {
        errors.push(this.$t('pwd.passwords_no_match'));
      }
      if (containsForbiddenChars) {
        errors.push(
          this.$t('pwd.thepasswordcontainsspaceorforbiddencharacters')
        );
      }
      if (!containsRequiredChars) {
        errors.push(
          this.$t(
            'pwd.thepasswordhastobe8charactersorlongerandmustinclude1numeralandspecialcharacter'
          )
        );
      }
      return { isValid: errors.length == 0, errors };
    },
    async resetPassword() {
      this.isLoading = true;

      // Validate form and display any potential errors
      const formStatus = this.validateForm();
      if (!formStatus.isValid) {
        this.clearErrors();

        formStatus.errors.forEach((err) => {
          this.addError(err);
        });

        this.isLoading = false;
        return;
      }



      //This hopefully will not be needed in future when all apps have moved to new reset password endpoints
      let method = 'post';
      let resetUrl = this.URL;

      const newPasswordChangeEndpointApps = [
        36,
        37,
        '5fb50fc5-e3d9-4a85-bf93-edecec1661a4',
        'Fuse Fleet',
        'DSI',
        12,
        'c196ddbe-ba8f-46cc-a547-d376250e65ef',
        'FIA SDC',
        'The data hub',
        'Lifesaver',
        "Greater Than AB"
      ];
      if (newPasswordChangeEndpointApps.includes(Number(this.appid)) || newPasswordChangeEndpointApps.includes(this.app)) {
        resetUrl = this.URL2;
        method = 'put';
      }

      console.log("This appid", this.appid);
      console.log("this app",this.app);
      console.log("reset url", resetUrl);
      // Send password change request
      try {
        await axios({
          method,
          url: resetUrl,
          data: {
            ...this.form,
            token: this.token
          },
          headers: {
            language: this.$i18n.locale
          }
        });

        this.clearErrors();
        this.isLoading = false;
        this.hasBeenReset = true;
      } catch (error) {
        this.clearErrors();
        this.isLoading = false;

        if (error.response?.status === 400 && error.response.data) {
          this.addError(error.response.data.Message);
        } else if (error.response?.status === 404) {
          this.addError(this.$t('pwd.token_expired'));
        } else {
          this.addError(this.$t('pwd.something_went_wrong'));
        }
      }

      return true;
    }
  },
  mounted() {
    this.token = new URL(location.href).searchParams.get("token");
    this.appid = new URL(location.href).searchParams.get("appid");
    this.app = new URL(location.href).searchParams.get("app");
  },
  props: {
    msg: String
  }
};
</script>

<style scoped lang="scss">
.error-msg {
  margin: 10px;
}
.container {
  margin: 0 auto;
  margin-top: 120px;
  width: 50vh;
  img {
    width: 150px;
  }

  .content {
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    h1,
    h4 {
      font-weight: 300;
    }
  }
}

.errorNotification {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 10px !important;
}

.password-icon{
  position: absolute;
  right: 31px;
  margin-top: 11px;
}
</style>
